import ProjectsPage, { handle } from '@modules/professional/page/ProjectsPage';
import { loader } from '@modules/professional/page/loaders/projects-page-loader.server';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';

export { loader, handle };
export const shouldRevalidate = shouldRevalidateLeaf;
export default ProjectsPage;
